
export const isIosDevice = () => {
  return /iPhone|iPad|iPod/.test(navigator.userAgent)
}

export const isAppleDevice = () => {
  return /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent)
}